import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { uiOpenModal } from '../../../../actions/ui'
// import { useDispatch } from 'react-redux'
// import { userStartLoading } from '../../../../actions/auth'
import { fetchConToken } from '../../../../helpers/fetch'



export const UsersAllScreen = () => {



const [users, setUsers] = useState([])

  useEffect(() => {
    
     fetchConToken('auth/users').then( resp => resp.json()).then(res => setUsers(res.users))
  }, [users])
        
  const dispatch = useDispatch()

  const handleUserModal = (user) =>{

    // console.log(item)
    dispatch( uiOpenModal(user) )
}
 
  return (
    <div>
      {
        users &&
      <div>

        Total de usuarios: {users.length}
      </div> 
      }
             <table>
    
        
            <thead >
              <tr >
                  <th style={{ width: 150 }} >Nombre</th>
                  <th style={{ width: 230 }} >Email</th>
                  {/* <th style={{ width: 120 }} >id</th> */}
                  <th style={{ width: 150 }} >password</th>
                  <th style={{ width: 120}} > rol</th>
                  {/* <th style={{ width: 70}} > update</th> */}
                  {/* <th style={{ width: 70}} > delete</th> */}
              </tr>
            </thead>

            <tbody>
          
              { users && users.length >= 1 &&
                users.map(user =>

                  <tr key={user.id} className="userAdminMenu" onClick={() => handleUserModal(user)}>
                    <td> {user.name } </td>
                    <td>{user.email }</td>
                    {/* <td> {user.id} </td> */}
                    <td>restricted</td>
                    <td > {user.acces}      </td>
                    {/* <td className='btn_green' onClick={() => handleUserModal(user)}>up</td> */}
                    {/* <td className='btn_red'>x</td> */}

                  </tr>
                  )
              }
            </tbody>
        
              


            </table>

              
      

      
    </div>

  )
}
